<script>
	import Menu from './Menu.svelte';
	import {createEventDispatcher} from "svelte";
	import {MaterialIcon} from "@ac/material-icons/src";

	export let items = [];
	export let level = 0;

	let hoveredItem = null;
	const dispatch = createEventDispatcher();

	function flipIfOverflow( node ) {
		const rect = node.getBoundingClientRect();

		if ( rect.right + 150 > window.innerWidth ) {
			node.classList.add( '-flip' );
		}
	}
</script>

<div role="menu" class="acp-metric-nav level-{level}">
	{#each items as item}
		{#if item.divider}
			<hr class="acp-metric-nav-divider"/>
		{:else if item.children}
			<div
				class="acp-metric-nav-item -has-children"
				role="menuitem"
				aria-haspopup="menu"
				tabindex="0"
				on:mouseenter={() => hoveredItem = item.key}
				on:mouseleave={() => hoveredItem = null}
			>
				<span class="menu-item-label">
					{item.label}
					<MaterialIcon icon="keyboard_arrow_right"/>
				</span>

				{#if hoveredItem === item.key}
					<div class="submenu-container" use:flipIfOverflow>
						<Menu on:click items={item.children} level={level + 1}/>
					</div>
				{/if}
			</div>
		{:else}
			<button
				type="button"
				role="menuitem"
				class="acp-metric-nav-item"
				on:click|preventDefault|stopPropagation={() => dispatch('click', item)}
			>
				{item.label}
			</button>
		{/if}
	{/each}
</div>